/**
 * Authentication Helper Functions
 * Manages deep link preservation across MSAL authentication
 */

const REDIRECT_KEY = "msal_redirect_url";

/**
 * Save the current URL before authentication
 * @param url - The URL to save (defaults to current location)
 */
export const saveRedirectUrl = (url?: string): void => {
  const urlToSave = url || globalThis.location.pathname + globalThis.location.search + globalThis.location.hash;
  
  // Only save non-root paths
  if (urlToSave && urlToSave !== "/" && urlToSave !== "") {
    localStorage.setItem(REDIRECT_KEY, urlToSave);
  }
};

/**
 * Get the saved redirect URL
 * @returns The saved URL or null if none exists
 */
export const getRedirectUrl = (): string | null => {
  return localStorage.getItem(REDIRECT_KEY);
};

/**
 * Clear the saved redirect URL
 */
export const clearRedirectUrl = (): void => {
  localStorage.removeItem(REDIRECT_KEY);
};

/**
 * Check if a URL is a protected route that requires authentication
 * @param path - The path to check
 * @returns true if the path requires authentication
 */
export const isProtectedRoute = (path: string): boolean => {
  const protectedPaths = [
    "/pre-launch",
    "/post-launch",
    "/admin",
    "/explore",
    "/pack-assessment",
  ];
  
  return protectedPaths.some(protectedPath => path.startsWith(protectedPath));
};
